import { css } from '@emotion/css';

import { MAX_DESKTOP_WIDTH_REM, mqBreakpoints } from '../../system-libraries/styles';
import { pxToRem } from '../../system-libraries/styles/utils';
import Config from '../../system-utils/config-manager';

import { FooterLink, FooterLinkData } from './FooterLink';

export const Footer = () => {
  const links = Config.get<Record<string, FooterLinkData>>('footer.links', {});

  return (
    <div className={styles.footer} data-testid='nba-footer'>
      <div className={styles.container}>
        <FooterLink data={links['legals']} />
        <FooterLink data={links['privacy_policy']} />
        <FooterLink data={links['cookies']} />
        <FooterLink data={links['accessibility']} />
        <FooterLink data={links['help']} />
      </div>
    </div>
  );
};

const styles = {
  footer: css({
    backgroundColor: 'var(--color-dark)',
    margin: '0 auto',
    marginBottom: pxToRem(80), // Raise the footer so the sticky tab nav doesn't cover it
    flexShrink: 0,
    height: pxToRem(232),
    width: '100%',
    zIndex: 10,
    [mqBreakpoints.tablet]: {
      height: pxToRem(192),
    },
    [mqBreakpoints.desktop]: {
      height: pxToRem(144),
      marginBottom: 0,
    },
  }),
  container: css({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    margin: '0 auto',
    paddingTop: pxToRem(32),
    paddingBottom: pxToRem(64),
    paddingLeft: pxToRem(32),
    with: '100%',
    height: '100%',
    maxWidth: MAX_DESKTOP_WIDTH_REM,

    [mqBreakpoints.tablet]: {
      paddingTop: pxToRem(40),
      paddingBottom: pxToRem(72),
      paddingLeft: pxToRem(48),
    },
    [mqBreakpoints.desktop]: {
      paddingLeft: pxToRem(120),
    },
  }),
};
